module.exports = __webpack_public_path__ + "img/P150T_weapon_122.a1164e2a.png";